import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCalendarRange } from '@fortawesome/pro-light-svg-icons';

export type ProLightCalendarRangeProps = IconComponentProps;

export const ProLightCalendarRange = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCalendarRangeProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCalendarRange}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCalendarRange}
    />
  );
};

ProLightCalendarRange.displayName = 'ProLightCalendarRange';
